import Helper from './Helper';

class Filtering {
  constructor(config = {}) {
		const {
			filterBoxContainerSelector,
			filterBoxSelector,
			filterBoxCount,
			loadMoreButtonSelector,
			filterButtonSelector,
			filterButtonDataAttribute,
			filterBoxDataAttribute
		} = config;

		this.filterBoxCount = filterBoxCount || 5,
		this.filterBoxContainer = document.querySelector(filterBoxContainerSelector);
		this.loadMoreButton = document.querySelector(loadMoreButtonSelector);
		this.filterButtonSelector = filterButtonSelector;
		this.filterBoxSelector = filterBoxSelector;
		this.filterBox = document.querySelectorAll(filterBoxSelector);
		this.filterButton = document.querySelectorAll(filterButtonSelector);

		this.filterButtonDataAttribute = filterButtonDataAttribute;
		this.filterBoxDataAttribute = filterBoxDataAttribute;
		this.filterBoxArray = Array.prototype.slice.call(this.filterBox);
		this.filterButtonArray = Array.prototype.slice.call(this.filterButton);

		if(this.filterBoxContainer){
			console.log('filtering');
			this.loadInitialView(this.filterBoxCount);
			this.bindEvents();
		}
  }

	loadInitialView(){
		Helper.addClass(document.querySelector(`${this.filterButtonSelector}[data-${this.filterButtonDataAttribute}='reset']`), 'active');

		for (let i = 0; i <= this.filterBoxCount; i++) {
			Helper.addClass(this.filterBoxArray[i], 'visible');
			setTimeout(() => { Helper.addClass(this.filterBoxArray[i], 'fade-in-up') }, 300);
		}

		window.dispatchEvent(new Event('scroll'));
	}

  bindEvents() {
		this.loadMoreButton.addEventListener('click', e => {
			this.loadMore(e);
		});

		this.filterButtonArray.forEach(button => {
      button.addEventListener('click', e => {
				const data = Helper.camelCase(this.filterButtonDataAttribute);
				const dataValue = button.dataset[data];
				this.setActiveButton(dataValue);
				this.filterBy(dataValue)
      })
		});
	}

	setActiveButton(dataVal){
		this.filterButtonArray.forEach(button => {
			Helper.removeClass(button, 'active');
		});
		Helper.addClass(document.querySelector(`${this.filterButtonSelector}[data-${this.filterButtonDataAttribute}=${dataVal}]`), 'active');
	}

	filterBy(dataVal){
		const allHiddenArray = Array.prototype.slice.call(document.querySelectorAll(`span.hidden`));
		allHiddenArray.forEach(hiddenEl => {
			this.resetHides(hiddenEl);
		});

		if(dataVal == 'reset'){
			const targets = Array.prototype.slice.call(document.querySelectorAll(`${this.filterBoxSelector}`));

			targets.forEach(target => {
				Helper.addClass(target, 'visible');
				setTimeout(() => { Helper.addClass(target, 'fade-in-up') }, 300);
			});
		} else {
			const targets = Array.prototype.slice.call(document.querySelectorAll(`${this.filterBoxSelector}[data-${this.filterBoxDataAttribute}=${dataVal}]`));
			const notTargets = Array.prototype.slice.call(document.querySelectorAll(`${this.filterBoxSelector}:not([data-${this.filterBoxDataAttribute}=${dataVal}])`));

			targets.forEach(target => {
				Helper.addClass(target, 'visible');
				setTimeout(() => { Helper.addClass(target, 'fade-in-up') }, 300);
			});

			notTargets.forEach(nonTarget => {
				this.hideElement(nonTarget);
			});
		}

		Helper.addClass(this.loadMoreButton.parentElement, 'hidden');
		window.dispatchEvent(new Event('scroll'));
	}

	loadMore(e){
		this.filterBoxArray.forEach(box => {
			Helper.addClass(box, 'visible');
			setTimeout(() => { Helper.addClass(box, 'fade-in-up') }, 300);
		});
		Helper.addClass(this.loadMoreButton.parentElement, 'hidden');
		window.dispatchEvent(new Event('scroll'));
	}

	hideElement(el){
		let wrapper = document.createElement('span');
		Helper.addClass(wrapper, 'hidden');
		Helper.wrap(el, wrapper);
	}

	resetHides(el){
		Helper.removeClass(el.firstChild, 'visible');
		Helper.removeClass(el.firstChild, 'fade-in-up');
		Helper.unwrap(el);
	}
}

export default Filtering;
